import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import { MEETINGS_ACTION } from '../../../content/actions/meeting.actions';
import KEYS from '../../../values/keys';
import { Meeting } from '@/content/models/meeting.model';
import { STORE } from '@/core/store/core.store';
import {MEETINGS_EVENTS} from '@/content/values/events';
import { MEETING_BASE_TYPES } from '@/meetings/values/meetings.values';

@Component({})
export default class EdMeetings extends Vue {
  
  /* Arguments */
  @Prop() readonly options: any; 
  @Prop() readonly createMeeting: any;
  @Prop() readonly activeId: any;

  /* Data */
  public isLoading: boolean = false;
  public activeMeeting: number = 0;

  /* Computed */
  get meetings(): Meeting[] { 
    var array = this.$store.state.TeacherPortalStore.meetings.filter(meeting=>{
      if(meeting.type==MEETING_BASE_TYPES.FREE)
        return meeting;
    });
    return array.sort((a,b) => {
      return Date.parse(a.startingDate) - Date.parse(b.startingDate);
    });
  }
  get loadingInfo(): any { return { [KEYS.CSS.EDG_SHIMMER_CONTAINER] : this.isLoading }; }

  /* Watch */
  @Watch('meetings')
  meetingsChanged(newValue: Meeting[]) {
    if(newValue.length > 0){
      setTimeout(()=> {
        this.$edEventBus.$emit(MEETINGS_EVENTS.SHOW_MEETING_DETAIL, newValue[0]);
      }, 3000);
    }
  }

  /* Hooks */
  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch(`${STORE.TEACHER_PORTAL.NAME}/${this.options.meetingsPath}`);  
    this.isLoading = false;
  }
} 